import { HTTP } from "@/utils/http";
import Apis from "@/apis";

const initialState = () => ({
    trackList: null,
    pagination:null,
    isLoading: false,
});

export default {
    namespaced: true,
    state: initialState,
    mutations: {
        updateTrackResult(state, data){
            if (data) 
            {
                // Added : pagination (to consume)
                state.pagination = 
                { 
                    page:data.page, pageSize:data.pageSize, count:data.count, pageCount:data.pageCount
                };
                state.trackList = data.items;
            }
            state.isLoading = false;
        },
        updateIsLoading :(state, isLoading) => state.isLoading= isLoading,
        setPageSize (state, pageSize) {
            state.pagination.pageSize = pageSize
        }
    },
    actions: {
        setPageSize ({ commit }, pageSize) {
            commit('setPageSize', pageSize)
        },
        async launch({commit}, searchParameters){
            console.log("updateIsLoading" , searchParameters)
            commit("updateIsLoading", true)
            if (searchParameters.type){
                commit("updateTrackResult", searchParameters.data);
            } else {
                return HTTP.post(Apis.library.tracks.search, searchParameters)
                    .then(response => {
                        commit("updateTrackResult", response.data.dataItem);
                    })
                    .catch(error => {
                        console.log(error);
                        commit("updateTrackResult", {});
                    })
            }

        }
    },
};
